import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react';
import { find, map } from 'lodash/fp';
import { BasicOdooObject } from '../utils/odoo';
import { CircleIcon, RoundedSquareIcon } from './Icon';
import './Many2OneSelector.scss';

interface Many2OneSelectorProps<T> {
    items: T[];
    value: string | number | null;
    icon: IconProp;
    label: string;
    lines?: 'none' | 'full' | 'inset' | undefined;
    backgroundColor?: string;
    disabled?: boolean;
    fieldToDisplay?: keyof T;
    onChange: (value: T | undefined) => void;
    selectOptions?: Omit<React.ComponentProps<typeof IonSelect>, 'value' | 'slot' | 'onIonChange'>;
}

export function Many2OneSelector<T extends BasicOdooObject & { [key: string]: any }>({
    items,
    value,
    icon,
    label,
    lines,
    disabled,
    fieldToDisplay,
    backgroundColor = 'white',
    onChange,
    selectOptions,
}: Many2OneSelectorProps<T>) {
    return (
        <IonItem lines={lines} style={{ '--background': backgroundColor }}>
            <IonLabel slot="start" className="!flex-none m-0">
                <RoundedSquareIcon icon={icon} />
            </IonLabel>
            <IonSelect
                value={value}
                label={label}
                justify="space-between"
                okText="Valider"
                cancelText="Annuler"
                disabled={disabled}
                onIonChange={(e) => onChange(find({ id: e.detail.value }, items))}
                className="pl-1"
                {...selectOptions}
            >
                {map(
                    (item) => (
                        <IonSelectOption key={item.id} value={item.id} disabled={item?.disabled}>
                            {`${fieldToDisplay ? item[fieldToDisplay] : item['name']}`}
                        </IonSelectOption>
                    ),
                    items
                )}
            </IonSelect>
        </IonItem>
    );
}

export const DateTimeSelector: React.FC<{
    value: string;
    icon: IconProp;
    label: string;
    onChange: (value: any) => void;
}> = ({ value, icon, label, onChange }) => {
    return (
        <IonItem className="bg-white">
            <CircleIcon icon={icon} size="text-2xl" />
            <IonLabel className="pl-1">{label}</IonLabel>
            <IonLabel slot="end">
                <input
                    type="datetime-local"
                    value={value}
                    className="text-right"
                    onChange={(e) => onChange(e.target.value)}
                />
            </IonLabel>
        </IonItem>
    );
};
